export default __webpack_public_path__ + "static/media/sv1.75109765.png";